module.exports = __webpack_public_path__ + "static/media/si.8be67718.svg";